import { buildFullName } from '@hilbi/web-common/utils/common';
import { CloseOutlined } from '@icon';
import { Button, IconButton } from '@ui';
import moment from 'moment';
import React from 'react';
import { TWaiting } from 'types/patients';
import { getDateFormat } from '../../../../helpers/utils-helpers';
import { PatientRequestSC } from './patient-request.styled';

type TProps = {
  waiting: TWaiting;
  onAccept: (item: TWaiting) => void;
  onReject: (item: TWaiting) => void;
};

const PatientRequest: React.FC<TProps> = ({ waiting, onAccept, onReject }) => {
  const { client, createdAt } = waiting;
  const defaultAvatar = require('../../../../assets/svg/avatar.svg').default;
  const fullName = buildFullName(
    client.profile.titleBeforeName,
    client.profile.firstName,
    client.profile.lastName,
    client.profile.titleAfterName,
  );

  return (
    <PatientRequestSC>
      <img className="avatar" src={client.profile.profileImage || defaultAvatar} alt="" />
      <div>
        <div className="name">{fullName}</div>
        <time>{moment(createdAt).format(getDateFormat())}</time>
      </div>
      <div className="actions">
        <Button variant="primary" onClick={() => onAccept(waiting)} size="medium" block={false}>
          Prijať
        </Button>
        <IconButton
          Icon={CloseOutlined}
          variant="danger-outlined"
          onClick={() => onReject(waiting)}
          size="medium"
        />
      </div>
    </PatientRequestSC>
  );
};

export default React.memo(PatientRequest);
